import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { massDestroySimpleStepItems } from "../../api/apiSimpleStepItems";
import parseError from "../../utils/parseError";

export function useDeleteAllSimpleStepItems() {
    const queryClient = useQueryClient();

    const { mutate: deleteAllItemsMutate, isPending } = useMutation({
        mutationFn: massDestroySimpleStepItems,
        onSuccess: (response) => {
            toast.success(response.message || "Deleted successfully");
            queryClient.invalidateQueries({ queryKey: ["simple-step-items"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to delete items");
        },
    });

    return { deleteAllItemsMutate, isPending };
}
